import {StringUtils} from "./StringUtils";
import {Utils} from './Utils';
import {ScriptLoadType} from "./CommonTypes";

var sizzle = require('sizzlejs');

/**
 * @class HtmlUtils - html utilities
 */
export class HtmlUtils {
    /**
     * @method queryElements - query for html elemenet using jQuery like syntax selector.
     * @param selector - jquery like syntax selector
     * @param context - context - if not specified then 'document' is used
     * @returns Array of founded elements.
     */
    public static queryElements(selector: string, context?: Node): Array<HTMLElement> {
        var result = sizzle(selector, context) as Array<HTMLElement>;
        /*if (lodash.isArray(result)) {
         if (result.length === 1) {
         return result[0];
         }
         }*/

        return result;
    }

    /**
     * @method hideElement - hides element by setting stlye 'display' to 'none'.
     * @param element
     */
    public static hideElement(element: HTMLElement): void {
        if (element) {
            element.style.display = 'none';
        }
    }

    /**
     * @method showElement - shows element by setting stlye 'display' to 'block'.
     * @param element
     */
    public static showElement(element: HTMLElement, display?: string): void {
        if (element) {
            display = Utils.valueOrDefault(display, 'block');
            element.style.display = display;
        }
    }

    /**
     * @method toggleShow - toggle visibility (via display: block or none) of element
     * @param element - element to toggle visibility
     * @param show - true to show element (via display: block) or false to hide element (via display: none)
     */
    public static toggleShow(element: HTMLElement, show: boolean) {
        if (show) {
            HtmlUtils.showElement(element);
        } else {
            HtmlUtils.hideElement(element);
        }
    }

    /**
     * @method delayedFocus - focus element after specified delay (in ms)
     * @param element - element to focus
     * @param delay - delay time in ms after which element is focused
     */
    public static delayedFocus(element: HTMLElement, delay: number) {
        if (delay < 0) {
            throw new Error('Parameter "delay" must be greater or equal to zero!');
        }

        if (element) {
            setTimeout(() => {
                element.focus();
            }, delay);
        }
    }

    /**
     * @method toggleClass - toggle css class on specified element according to param 'show'
     * @param element - element to toggle css class on
     * @param show - flag which class to toggle
     * @param trueClass - if param 'show' is true than value of this param is added to css class list of element
     * @param falseClass - if param 'show' is false than value of this param is added to css class list of element
     */
    public static toggleClass(element: HTMLElement, show: boolean, trueClass: string, falseClass: string) {
        if (element) {
            var classToRemove = show ? falseClass : trueClass;
            var classToAdd = show ? trueClass : falseClass;

            if (!StringUtils.isNullOrEmpty(classToRemove)) {
                element.classList.remove(classToRemove);
            }

            if (!StringUtils.isNullOrEmpty(classToAdd) && !element.classList.contains(classToAdd)) {
                element.classList.add(classToAdd);
            }
        }
    }

    /**
     * method addScriptToDocument - adds <script> tag into document <head> with specified 'src' value.
     * @param value - URI to JS script (when type is @ScriptLoadType.Url) or JS content (when type is @ScriptLoadType.Content)
     */
    public static addScriptToDocument(type: ScriptLoadType, value: string): void {
        let head = document.getElementsByTagName('head')[0];
        let script = document.createElement('script');
        script.type = 'text/javascript';
        if (type === ScriptLoadType.Url) {
            script.src = value;
        } else {
            script.text = value;
        }

        head.appendChild(script);
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/HtmlUtils.ts
 **/